import { default as React, FunctionComponent, useEffect } from 'react'
import { NavLink, Route, Routes, useParams } from 'react-router-dom'
import useThunkDispatch from '../useThunkDispatch'
import { useSelector } from 'react-redux'
import { detailedAccountSelector } from '../../accounts/accountsSelectors'
import { find, isEmpty } from 'lodash/fp'
import { requestDetailedAccount } from '../../accounts/accountsActions'
import { managerAccountBranchesSelector } from '../../manager/managerSelectors'
import { IAccount, IBranch } from '../../types/user'
import withAccountAndBranch from '../withAccountAndBranch'
import { getShouldRenderTruckInventoryFeature } from '../getShouldRenderTruckInventoryFeature'
import { getShouldRenderBinInventoryFeature } from '../getShouldRenderBinInventoryFeature'

interface IOwnProps {
  account?: IAccount
}

const SubHeaderComponent: FunctionComponent<IOwnProps> = ({
  account: currentAccount,
}) => {
  const { accountId, '*': rest } = useParams()
  const branchId = rest?.match(/^branches\/(\d+)/)?.[1]

  const dispatch = useThunkDispatch()
  const account = useSelector(detailedAccountSelector)
  const branches: IBranch[] = useSelector(managerAccountBranchesSelector)

  useEffect(() => {
    if ((isEmpty(account) || isEmpty(branches)) && accountId)
      dispatch(requestDetailedAccount(parseInt(accountId, 10)))
  }, [])

  // const account = accounts[accountId]
  const branch = branchId && find({ id: Number(branchId) }, branches)

  if (!account || !branch) {
    return <></>
  }

  const ordersEnabled = currentAccount?.ordersEnabled ?? true

  const shouldRenderTruckInventoryFeature =
    getShouldRenderTruckInventoryFeature(
      account?.truckInventoryFeature,
      branch?.truckInventoryFeature,
    )

  const shouldRenderBinInventoryFeature = getShouldRenderBinInventoryFeature(
    account?.binInventoryFeature,
    branch?.binInventoryFeature,
  )

  return (
    <div className="subheader_menu">
      <NavLink
        end
        className={({ isActive }) =>
          isActive ? 'menu_root-link link -active' : 'menu_root-link link'
        }
        to={`/clients/${accountId}/branches/${branch.id}`}
      >
        Replenishment Plan
      </NavLink>
      <NavLink
        className={({ isActive }) =>
          isActive ? 'menu_root-link link -active' : 'menu_root-link link'
        }
        to={`/clients/${accountId}/branches/${branch.id}/inventory`}
      >
        Inventory
      </NavLink>
      <NavLink
        className={({ isActive }) =>
          isActive ? 'menu_root-link link -active' : 'menu_root-link link'
        }
        to={`/clients/${accountId}/branches/${branch.id}/users`}
      >
        Users
      </NavLink>
      <NavLink
        className={({ isActive }) =>
          isActive ? 'menu_root-link link -active' : 'menu_root-link link'
        }
        to={`/clients/${accountId}/branches/${branch.id}/groups`}
      >
        Divisions & Teams
      </NavLink>

      {ordersEnabled && (
        <NavLink
          className={({ isActive }) =>
            isActive ? 'menu_root-link link -active' : 'menu_root-link link'
          }
          to={`/clients/${accountId}/branches/${branch.id}/orders`}
        >
          Orders
        </NavLink>
      )}

      <NavLink
        className={({ isActive }) =>
          isActive ? 'menu_root-link link -active' : 'menu_root-link link'
        }
        to={`/clients/${accountId}/branches/${branch.id}/inbound_inventories`}
      >
        Inbound Inventory
      </NavLink>

      {(shouldRenderTruckInventoryFeature ||
        shouldRenderBinInventoryFeature) && (
        <NavLink
          className={({ isActive }) =>
            isActive ? 'menu_root-link link -active' : 'menu_root-link link'
          }
          to={`/clients/${accountId}/branches/${branch.id}/locations`}
        >
          Locations
        </NavLink>
      )}

      {(shouldRenderTruckInventoryFeature ||
        shouldRenderBinInventoryFeature) && (
        <NavLink
          className={({ isActive }) =>
            isActive ? 'menu_root-link link -active' : 'menu_root-link link'
          }
          to={`/clients/${accountId}/branches/${branch.id}/cycle_counts`}
        >
          Cycle Counts
        </NavLink>
      )}
    </div>
  )
}

const WrappedSubHeader = withAccountAndBranch(SubHeaderComponent)

const SubHeaderInternal = () => (
  <Routes>
    <Route path="/clients/:accountId/*" element={<WrappedSubHeader />} />
  </Routes>
)

export default SubHeaderInternal
